module.exports = __webpack_public_path__ + "static/media/img2.347a0692.jpeg";